import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { useLockBodyScroll } from '@app/helpers';

import { FiltersGroup } from '../../FiltersGroup.tsx';
import { FiltersSidebar } from '../../FiltersSidebar/FiltersSidebar.tsx';

import { CloseButton, Wrapper } from './FiltersModal.style';

export interface FiltersModalProps {
    open?: boolean;
    setOpen: (open: boolean) => void;
}

export function FiltersModal({ open = false, setOpen }: FiltersModalProps) {
    useLockBodyScroll(open);

    return (
        <AnimatePresence initial={false}>
            {open && (
                <Wrapper initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 60 }}>
                    <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>

                    <FiltersSidebar>
                        <FiltersGroup />
                    </FiltersSidebar>
                </Wrapper>
            )}
        </AnimatePresence>
    );
}
